exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-create\r\n{\r\n    padding: -15px;\r\n}\r\n.user-create label\r\n{\r\n    font-weight: bold;\r\n} ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account-edit/account-edit.component.css
// module id = ../../../../../src/app/account-edit/account-edit.component.css
// module chunks = main